import { getStoreCode } from '~/lib/getStoreCode'

type StoreCodeProps = {
  locale: string | undefined
}

export const parseSampleBoxCategory = ({ locale }: StoreCodeProps) => {
  const currentStore = getStoreCode({ locale })

  switch (currentStore) {
    case 'benuta_fr':
      return 'echantillons-tapis.html'
    case 'benuta_chfr':
      return 'echantillons-tapis.html'
    case 'benuta_es':
      return 'muestras-alfombras.html'
    case 'benuta_it':
      return 'campioni-tappeti.html'
    case 'benuta_chit':
      return 'campioni-tappeti.html'
    case 'benuta_co_uk':
    case 'benuta_eu':
      return 'rug-samples.html'
    case 'benuta_nl':
      return 'vloerkleed-samples.html'
    case 'benuta_pl':
      return 'probki-dywanow.html'
    case 'benuta_se':
      return 'mattprover.html'
    case 'benuta_dk':
      return 'taeppeprover.html'
    case 'benuta_pt':
      return 'amostras-de-tapete.html'
    case 'benuta_fi':
      return 'mattonaytteet.html'
    case 'benuta_cz':
      return 'vzorky-kobercu.html'
    case 'benuta_no':
      return 'teppeprover.html'
    case 'benuta_chde':
      return 'teppichmuster.html'
    default:
      return 'teppichmuster.html'
  }
}
